import api from "./api";
const svc = {
  listar:      (p={}) => { const qs=new URLSearchParams(Object.entries(p).filter(([,v])=>v!==""&&v!==undefined)); return api("GET",`/areas-comuns?${qs}`); },
  buscarPorId: id     => api("GET",`/areas-comuns/${id}`),
  criar:       data   => api("POST","/areas-comuns",data),
  atualizar:   (id,data) => api("PUT",`/areas-comuns/${id}`,data),
  deletar:     id     => api("DELETE",`/areas-comuns/${id}`),
  verificarDisponibilidade: (p) => { const qs=new URLSearchParams(p); return api("GET",`/areas-comuns/disponibilidade?${qs}`); },
  listarBloqueios: id => api("GET",`/areas-comuns/${id}/bloqueios`),
  criarBloqueio:   (id,data) => api("POST",`/areas-comuns/${id}/bloqueios`,data),
  deletarBloqueio: (id,bid)  => api("DELETE",`/areas-comuns/${id}/bloqueios/${bid}`),
};
export default svc;
